import React from 'react'
import PropTypes from 'prop-types'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { GridWrapper, TableWrapper } from './style'

const Grid = ({ gridData }) => {
  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2, maxWidth: '800px' }}>
        <TableContainer>
          {gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                <TableCell>Email Address</TableCell>
                <TableCell>Hours</TableCell>
                <TableCell>Count</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row.EmailAddress}</TableCell>
                    <TableCell>{row.Hours}</TableCell>
                    <TableCell>{row.ActivityCount}</TableCell>
                    <TableCell>{row.Action}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}

          {gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

Grid.propTypes = {
  gridData: PropTypes.array
}

export default Grid
